import { useState, useEffect } from 'react';
import { getProfile, updateProfile, updatePassword, uploadAvatar } from '../../services/profile';
import { useAuth } from '../../context/AuthContext';

export default function Profile() {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [stats, setStats] = useState({});
  const [form, setForm] = useState({ name: '', phone: '', bio: '' });
  const [passForm, setPassForm] = useState({ current_password: '', password: '', password_confirmation: '' });
  const [msg, setMsg] = useState('');
  const [tab, setTab] = useState('info');

  useEffect(() => {
    getProfile().then(r => {
      setProfile(r.data.user);
      setStats(r.data.stats);
      setForm({ name: r.data.user.name || '', phone: r.data.user.phone || '', bio: r.data.user.bio || '' });
    });
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await updateProfile(form);
      setMsg('Ma\'lumotlar yangilandi!');
      setTimeout(() => setMsg(''), 3000);
    } catch (err) { setMsg('Xatolik yuz berdi'); }
  };

  const handlePassword = async (e) => {
    e.preventDefault();
    try {
      await updatePassword(passForm);
      setPassForm({ current_password: '', password: '', password_confirmation: '' });
      setMsg('Parol yangilandi!');
      setTimeout(() => setMsg(''), 3000);
    } catch (err) { setMsg(err.response?.data?.message || 'Xatolik'); }
  };

  const handleAvatar = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const r = await uploadAvatar(file);
      setProfile(p => ({ ...p, avatar_url: r.data.avatar_url }));
    } catch (err) { setMsg('Rasm yuklanmadi'); }
  };

  if (!profile) return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-500 border-t-transparent"></div></div>;

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      {/* Profile Header */}
      <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
        <div className="flex items-center gap-6">
          <label className="cursor-pointer group relative">
            <div className="w-20 h-20 rounded-2xl bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-3xl text-white font-bold overflow-hidden">
              {profile.avatar_url ? <img src={profile.avatar_url} className="w-full h-full object-cover" /> : profile.name?.charAt(0)?.toUpperCase()}
            </div>
            <div className="absolute inset-0 bg-black/50 rounded-2xl opacity-0 group-hover:opacity-100 flex items-center justify-center text-white text-xs transition">Rasm yuklash</div>
            <input type="file" accept="image/*" className="hidden" onChange={handleAvatar} />
          </label>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{profile.name}</h1>
            <p className="text-gray-500">{profile.email}</p>
            <div className="flex items-center gap-4 mt-2">
              <span className="text-sm bg-blue-100 text-blue-700 px-3 py-1 rounded-full font-medium capitalize">{profile.role}</span>
              <span className="text-sm text-gray-500">{stats.xp_points || 0} XP</span>
              <span className="text-sm text-gray-500">Daraja {stats.level || 1}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-white rounded-xl p-4 text-center border border-gray-100"><div className="text-2xl font-bold text-blue-600">{stats.courses_enrolled || 0}</div><div className="text-xs text-gray-500">Kurslar</div></div>
        <div className="bg-white rounded-xl p-4 text-center border border-gray-100"><div className="text-2xl font-bold text-green-600">{stats.courses_completed || 0}</div><div className="text-xs text-gray-500">Tugatilgan</div></div>
        <div className="bg-white rounded-xl p-4 text-center border border-gray-100"><div className="text-2xl font-bold text-purple-600">{stats.certificates || 0}</div><div className="text-xs text-gray-500">Sertifikatlar</div></div>
        <div className="bg-white rounded-xl p-4 text-center border border-gray-100"><div className="text-2xl font-bold text-orange-600">{stats.achievements || 0}</div><div className="text-xs text-gray-500">Yutuqlar</div></div>
      </div>

      {msg && <div className="bg-green-100 text-green-700 px-4 py-3 rounded-xl text-sm">{msg}</div>}

      {/* Tabs */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="flex border-b border-gray-100">
          <button onClick={() => setTab('info')} className={`px-6 py-3 text-sm font-medium ${tab === 'info' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`}>Ma'lumotlar</button>
          <button onClick={() => setTab('password')} className={`px-6 py-3 text-sm font-medium ${tab === 'password' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`}>Parol</button>
        </div>
        <div className="p-6">
          {tab === 'info' && (
            <form onSubmit={handleUpdate} className="space-y-4 max-w-lg">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ism</label>
                <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Telefon</label>
                <input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none" placeholder="+998 90 123 45 67" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Bio</label>
                <textarea value={form.bio} onChange={e => setForm({...form, bio: e.target.value})} rows={3} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none" />
              </div>
              <button type="submit" className="px-6 py-2.5 bg-blue-600 text-white rounded-xl text-sm font-medium hover:bg-blue-700 transition">Saqlash</button>
            </form>
          )}
          {tab === 'password' && (
            <form onSubmit={handlePassword} className="space-y-4 max-w-lg">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Joriy parol</label>
                <input type="password" value={passForm.current_password} onChange={e => setPassForm({...passForm, current_password: e.target.value})} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Yangi parol</label>
                <input type="password" value={passForm.password} onChange={e => setPassForm({...passForm, password: e.target.value})} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Parolni tasdiqlang</label>
                <input type="password" value={passForm.password_confirmation} onChange={e => setPassForm({...passForm, password_confirmation: e.target.value})} className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none" />
              </div>
              <button type="submit" className="px-6 py-2.5 bg-blue-600 text-white rounded-xl text-sm font-medium hover:bg-blue-700 transition">Parolni yangilash</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}